<template>
  <button
    class="ab-ui-btn"
    :class="[
      `ab-ui-btn--variant-${variant}`,
      { 'ab-ui-btn--block': block, 'ab-ui-btn--disabled': disabled },
      variant === 'primary' ? 'primary' : null
    ]"
    :type="type"
    :disabled="disabled || loading"
    @click="$emit('click', $event)"
  >
    <span v-if="loading" class="ab-ui-btn__loader" />
    <span class="ab-ui-btn__label">
      <slot />
    </span>
  </button>
</template>

<script>
export default {
  name: 'AbUiButton',
  props: {
    type: {
      type: String,
      default: 'button',
    },
    variant: {
      type: String,
      default: 'primary', // primary | secondary | outline | danger
    },
    block: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.ab-ui-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 999px;
  height: 36px;
  padding: 0 16px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: background-color 0.15s ease, box-shadow 0.15s ease, transform 0.05s ease;
  white-space: nowrap;
}

.ab-ui-btn--block {
  width: 100%;
}

.ab-ui-btn--variant-primary {
  /* rely on Vuetify `.primary` theme class for background; force white text */
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.ab-ui-btn--variant-primary:hover {
  filter: brightness(1.05);
}

.ab-ui-btn--variant-secondary {
  background-color: #f5f5f5;
  color: #333;
}

.ab-ui-btn--variant-outline {
  background-color: #fff;
  color: var(--v-theme-primary, #ff4b2b);
  border: 1px solid var(--v-theme-primary, #ff4b2b);
}

.ab-ui-btn--variant-danger {
  background-color: #f44336;
  color: #fff;
}

.ab-ui-btn--disabled {
  opacity: 0.6;
  cursor: default;
  box-shadow: none;
}

.ab-ui-btn__label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.ab-ui-btn__loader {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  animation: ab-ui-btn-spin 0.7s linear infinite;
}

@keyframes ab-ui-btn-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>

